"use client";

import Image from "next/image";
import { ReactNode } from "react";
import { motion } from "framer-motion";
import styles from "./Banner.module.css";

interface BannerProps {
  imageUrl: string;
  imageAlt: string;
  imagePosition?: "left" | "right";
  height?: number;
  width?: number;
  background: string;
  children: ReactNode;
}

const Banner = ({
  imageUrl,
  imageAlt,
  imagePosition = "left",
  height = 550,
  width = 550,
  background,
  children,
}: BannerProps) => {
  return (
    <div className={styles.wrapper} style={{ background }}>
      <motion.div
        className={`${styles.banner} ${
          imagePosition === "right" ? styles.imageRight : ""
        }`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <motion.div
          className={styles.imageContainer}
          initial={{ x: imagePosition === "right" ? 100 : -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <Image
            src={imageUrl}
            alt={imageAlt}
            width={width}
            height={height}
            priority
            style={{ objectFit: "contain" }}
          />
        </motion.div>
        <motion.div
          className={styles.textContent}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          {children}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Banner;
